"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TablePaginationActions = TablePaginationActions;
var _material = require("@mui/material");
var _FirstPageIcon = _interopRequireDefault(require("mdi-react/FirstPageIcon"));
var _KeyboardArrowLeftIcon = _interopRequireDefault(require("mdi-react/KeyboardArrowLeftIcon"));
var _KeyboardArrowRightIcon = _interopRequireDefault(require("mdi-react/KeyboardArrowRightIcon"));
var _LastPageIcon = _interopRequireDefault(require("mdi-react/LastPageIcon"));
var _mui = require("tss-react/mui");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useStyles = (0, _mui.makeStyles)()(theme => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.primary,
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(1.5)
  }
}));
function TablePaginationActions({
  backIconButtonProps,
  nextIconButtonProps,
  getItemAriaLabel,
  showFirstButton,
  showLastButton,
  count,
  onPageChange = () => {},
  page,
  rowsPerPage,
  dataTestidPrefix
}) {
  const {
    classes
  } = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: classes.root,
    children: [showFirstButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, {
      title: getItemAriaLabel('first'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
          "data-testid": dataTestidPrefix ? dataTestidPrefix + '-first' : undefined,
          onClick: event => onPageChange(event, 0),
          disabled: page === 0,
          color: "inherit",
          size: "large",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FirstPageIcon.default, {})
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, {
      title: getItemAriaLabel('previous'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
          ...backIconButtonProps,
          "data-testid": dataTestidPrefix ? dataTestidPrefix + '-previous' : undefined,
          onClick: event => onPageChange(event, page - 1),
          disabled: page === 0,
          color: "inherit",
          size: "large",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_KeyboardArrowLeftIcon.default, {})
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, {
      title: getItemAriaLabel('next'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
          ...nextIconButtonProps,
          "data-testid": dataTestidPrefix ? dataTestidPrefix + '-next' : undefined,
          onClick: event => onPageChange(event, page + 1),
          disabled: page >= Math.ceil(count / rowsPerPage) - 1,
          color: "inherit",
          size: "large",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_KeyboardArrowRightIcon.default, {})
        })
      })
    }), showLastButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, {
      title: getItemAriaLabel('last'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
          "data-testid": dataTestidPrefix ? dataTestidPrefix + '-last' : undefined,
          onClick: event => onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1)),
          disabled: page >= Math.ceil(count / rowsPerPage) - 1,
          color: "inherit",
          size: "large",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LastPageIcon.default, {})
        })
      })
    })]
  });
}
//# sourceMappingURL=TablePaginationActions.js.map